const forge = require('node-forge');
const passphrase = "FMISquFE&#MNj#R^agmhSIZ$s9mjbT#3Rw)mWWvf^uLzwHUGZuxYw&evrR^h%5@G";

const privateKeyPem = `-----BEGIN RSA PRIVATE KEY-----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-----END RSA PRIVATE KEY-----`;

const publicKeyPem = `-----BEGIN PUBLIC KEY-----
MIICIjANBgkqhkiG9w0BAQEFAAOCAg8AMIICCgKCAgEAkfJ5HShPL9x2PURyEeTW
lgn1mq73Wr1As8S2nZ7mGar3NSNaiMFMHkTIQF/S/QCUDCscpqOeBKZqbiZj0rxm
7Dy70MnXYHhZk6W9wYiFfquzQxxT0e3bTRu3ccjmYVmB4LMD3DwvK/haf01/KDS3
wH2i0d274XwEt8zNTmKzC1iVnPsieshKiwu60/pwCS6XbqzUITYH3ejStCuCj8wJ
K2MCg7ydUEtFJ5TX8ozJxLpH0eGzp6YTzWPO8WrKe1tfLa9901qkHinUSPI6wXsj
PINRtvnidmh4M0oqKGXjGHsbexngK1G9q8DKtZ3YRZ4MMoSBO/66X2ODdFZ7Gi8g
9Mt9RZR6phK4STYIRIoWHq2uUxPW977ehB8ot7tsjkLwK2pXu+ggPZthstujiQ3h
aEk07k/eKNQddQ5PBFnJCTaS3VStP79fXePD6AwblXgemGnYQZdH82S5I4ed/Yaz
nbu6Yjdg9zDm9dyGPFV/EXOX4gE9YFiVq6dLHGbT2rGBqDO9lKm34TuAGz5R3+Mk
rQSN/lj5ugwWyHtSq7c6tITgmAk7r+EQQTSdcSKNWA6g6qswmAe3cXXrh+SCZ0/A
YA6X1hT3F1PsmC9kZ9rdQkYj1sGJd3rOlqz5o2/RvuepXw8FegS6kQEkU9DxKz8o
oCffI21x/oPv0kKAWm5dBnkCAwEAAQ==
-----END PUBLIC KEY-----
`;
const {pki} = forge;
let privateKey = pki.decryptRsaPrivateKey(privateKeyPem, passphrase);
let publicKey  = pki.publicKeyFromPem(publicKeyPem);

// // Encrypt message
// export function encryptMessage(data) {
//     let plaintext = JSON.stringify(data);
//     let encryptedText = forge.util.bytesToHex(publicKey.encrypt(plaintext, 'RSA-OAEP', {
//         md: forge.md.sha512.create()
//     }));
//     console.log({encryptedText});
//     return encryptedText
// }

export function encryptMessage(data) {
    let plaintext = JSON.stringify(data);
    const maxChunkSize = 214; 

    let encryptedText = '';
    for (let i = 0; i < plaintext.length; i += maxChunkSize) {
        const chunk = plaintext.slice(i, i + maxChunkSize);
        const encryptedChunk = publicKey.encrypt(chunk, 'RSA-OAEP', {
            md: forge.md.sha512.create()
        });
        encryptedText += forge.util.bytesToHex(encryptedChunk);
    }
    
    // console.log({ encryptedText });
    return encryptedText;
}

export function  decryptMessage(encryptedMessage) { 
    // Split the encrypted message into chunks
    const encryptedChunks = encryptedMessage.match(/.{1,1024}/g);
   
    let decryptedMessage = '';
    console.log("inside decrypt")
    encryptedChunks.forEach(chunk => {
      const encryptedBytes = forge.util.hexToBytes(chunk);
      const decryptedChunk = privateKey.decrypt(encryptedBytes, 'RSA-OAEP', {
        md: forge.md.sha512.create(),
        mgf1: {
          md: forge.md.sha512.create()
        }
      });
    //   console.log("🚀 ~ file: crypto_service.js:99 ~ decryptMessage ~ decryptedChunk:", decryptedChunk);
      decryptedMessage += decryptedChunk;
    });
    // console.log({decryptedMessage});
    return JSON.parse(decryptedMessage);
  };

// Decrypt message
// export function decryptMessage(ciphertext) {
//     let decryptedText = JSON.parse(privateKey.decrypt(forge.util.hexToBytes(ciphertext), 'RSA-OAEP', {
//         md: forge.md.sha512.create()
//     }));
//     console.log({decryptedText});

//     return decryptedText;
// }

// Example usage
// let data = {
//     "mobile_number": "9999999999",
//     "mode": "LOGIN",
//     "dsa_hash": "c8c1857bf09b836a487564603dd93468b061f0ac461471de08d0f83116791e4b",
//     "utm_params": {
//       "utm_source": null,
//       "utm_medium": null,
//       "utm_campaign": null,
//       "utm_term": null,
//       "utm_content": null
//     }
//   }
// const plaintext = 'Ashish Shetty';
// const ciphertext = encryptMessage(JSON.stringify(data));
// console.log('Ciphertext (hex):', ciphertext);
// ciphertext = "97152d49c7a1c87650b1e8f75a6f477eff98f5961f5db530191f2d109531e5ed992630c0ec5ec76391b037365c62f04a60a86331fd6361c15f205edd1c0dedb9f38721242e023be614eef1ab44e4b9ac85839614bfccc634127c5794a4e1ef29605b0266e2e008a510990e0f3e382a75ecf541f7c404b4bd390dc25291e1d9374c2dc81baf550aa4b6ed8f2fcd880b83349d726496cf1c4c6c15ea87704dbd225dafd7c3f9c8f38fd29dfa345c7440b470e41017f221c9bf1a4f88624ab3343be46c1eb83e5cafdd31c2db4324e6c3e978b63aa7fc57cdc7e5cdc8579c4fd41907397a9739e4f84568d583dce3dd753837923ea10ae6bc9986f20dc92a7ff350caa8ca480122f26952467cf3cef67630cf9e392fb6fe66b9a177ded200d57170bdbf2b309492c13e18f9773e90b510cbbd92913fe4cd4d0c601849fa2b122ea3411b97027bd6aac4dfaa1e7febc2adc0bd0085156859a11ec994e4316cc72de11339b201c33e8b3d202a3919b9233abc129572b53c9a6ef7034a2b67e03098518c31eb1965b5d42478d10568679f83d87e9e4480b60c8def91bd9ff693002bcbd09f6c67cef2f340fc2f0f889a0c8b3d85cadcfc817ea227ce1dec29bcf0c54423acb62b679ddefda773712694fc44bab6179f765d3191c84cfc54fb611bf6af6a1703197366c3a5719d3391d5a734d6a2b5906e2fa868493ef1c9b3c3a3296f";
// const decryptedPlaintext = decryptMessage(ciphertext);
// console.log('Decrypted plaintext:', decryptedPlaintext);
